<template>

  <div
    id="app"
    style="width:100vw;padding-right: calc(100vw - 100%);"
  ><el-scrollbar v-if="ignoreIframe()" style="height:100%; width:100%">
    <router-view /></el-scrollbar>
    <router-view v-if="!ignoreIframe()"/>
  </div>

</template>
<script>
export default {
        methods: {
        ignoreIframe(){
            let flag=true;
            if(this.$route.path.indexOf("portfoliodiagnostic")>0 || this.$route.path.indexOf("manager-tagging")>0){
                flag=false;
            }
            return flag;
        }
    }
}

</script>
<style>
@import "./public/sass/common";
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

.icon_home {
    background: url("./public/images/icon_home.png") left no-repeat;
}
.icon_home:before {
    content: "\8fd4";
    font-size: 20px;
    margin-right: 8px;
    visibility: hidden;
}
.icon_import {
    background: url("./public/images/icon_import.png") left no-repeat;
    background-size: 19px;
}
.icon_export {
    background: url("./public/images/icon_export.png") left no-repeat;
    background-size: 19px;
}
.icon_download {
    background: url("./public/images/icon_download.png") left no-repeat;
    background-size: 19px;
}
.icon_set {
    background: url("./public/images/icon_set.png") left no-repeat;
    background-size: 19px;
}
.icon_import:before {
    content: "\8fd4";
    margin-right: 15px;
    visibility: hidden;
}
.icon_export:before {
    content: "\8fd4";
    margin-right: 15px;
    visibility: hidden;
}
.icon_download:before {
    content: "\8fd4";
    margin-right: 15px;
    visibility: hidden;
}
.icon_set:before {
    content: "\8fd4";
    margin-right: 15px;
    visibility: hidden;
}
.image_url_minus {
    background: url("./public/images/icon_minus.png") left no-repeat;
}
.image_url_plus {
    background: url("./public/images/icon_plus.png") left no-repeat;
}
</style>
